module.exports = __webpack_public_path__ + "img/local-3.1a062b97.jpg";